import React, { useState, useEffect } from "react";
import { MapPin, Bed, Bath, Square, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Reveal from "../components/Reveal";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "./Properties.css";

const Properties = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "properties"));
        const props = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setProperties(props);
      } catch (error) {
        console.error("Error fetching properties: ", error);
      }
      setLoading(false);
    };

    fetchProperties();
  }, []);

  const handleInquire = (propertyTitle) => {
    navigate(`/contact?inquiry=${encodeURIComponent(propertyTitle)}`);
  };

  return (
    <div className="properties-page">
      <section className="page-header properties-header">
        <div className="container">
          <Reveal>
            <h1>Exclusive Properties</h1>
            <p>
              Discover our curated selection of verified properties for sale. Find
              your dream home or next investment opportunity.
            </p>
          </Reveal>
        </div>
      </section>

      <div className="container">
        {loading ? (
          <div className="text-center py-5">
            <h3>Loading properties...</h3>
          </div>
        ) : (
          <div className="properties-grid">
            {properties.map((property, index) => (
              <Reveal key={property.id} delay={index * 100} className="property-card">
                <div className="property-image-container" onClick={() => navigate(`/properties/${property.id}`)} style={{cursor: 'pointer'}}>
                  <img
                    src={property.image}
                    alt={property.title}
                    className="property-image"
                  />
                  <span className="property-tag">{property.tag}</span>
                  {property.price && <div className="property-price-tag">₦{property.price}</div>}
                </div>
                
                <div className="property-details">
                  <h3 className="property-title">{property.title}</h3>
                  <div className="property-location">
                    <MapPin size={16} style={{ marginRight: "6px" }} />
                    {property.location}
                  </div>

                  <div className="property-features">
                    <div className="feature">
                      <Bed size={18} />
                      <span>{property.beds} Beds</span>
                    </div>
                    <div className="feature">
                      <Bath size={18} />
                      <span>{property.baths} Baths</span>
                    </div>
                    <div className="feature">
                      <Square size={18} />
                      <span>{property.sqft} sqft</span>
                    </div>
                  </div>

                  <button
                    className="property-btn"
                    onClick={() => navigate(`/properties/${property.id}`)}
                  >
                    View Details
                  </button>
                </div>
              </Reveal>
            ))}
            {properties.length === 0 && (
              <div className="text-center w-100 py-5">
                <h3>No properties found. Check back soon!</h3>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Properties;
